import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import "./LanguageToggle.css";

function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label="Toggle language"
    >
      <span className={`lang-option ${language === "en" ? "active" : ""}`}>
        EN
      </span>
      <span className="lang-divider">/</span>
      <span className={`lang-option ${language === "ru" ? "active" : ""}`}>
        RU
      </span>
    </button>
  );
}

export default LanguageToggle;
